import { Text, Title } from "@clipboard-health/ui-components";
import { CardContent, Divider, List, ListItem, ListItemText, Stack } from "@mui/material";
import { CbhFeatureFlag, useCbhFlags } from "@src/appV2/FeatureFlags";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { Fragment } from "react";

import { defaultWorkerToWorkplaceIncentive } from "../constants";
import { WorkplaceReferralCard } from "./WorkplaceReferralCard/WorkplaceReferralCard";

export function BonusBreakdown() {
  const ldFlags = useCbhFlags();
  const workplaceReferralsConfig = ldFlags[CbhFeatureFlag.WORKPLACE_REFERRALS] ?? {};
  const workerToWorkplaceIncentive =
    workplaceReferralsConfig.workerToWorkplaceIncentive ?? defaultWorkerToWorkplaceIncentive;

  const sortedIncentives = Object.entries(workerToWorkplaceIncentive).sort(
    (firstWorkplaceIncentive, secondWorkplaceIncentive) => {
      const incentiveDifference = secondWorkplaceIncentive[1] - firstWorkplaceIncentive[1];

      if (incentiveDifference === 0) {
        return firstWorkplaceIncentive[0].localeCompare(secondWorkplaceIncentive[0]);
      }

      return incentiveDifference;
    }
  );

  return (
    <WorkplaceReferralCard>
      <CardContent
        sx={(theme) => ({
          backgroundColor: theme.palette.common.white,
          paddingX: 5,
          paddingY: 7,
        })}
      >
        <Stack spacing={2}>
          <Title bold component="h5">
            What You&apos;ll Earn
          </Title>

          <List sx={{ padding: 0 }}>
            {sortedIncentives.map(([workplaceType, incentive], index) => (
              <Fragment key={workplaceType}>
                <ListItem sx={{ paddingY: 4 }}>
                  <ListItemText
                    primary={
                      <Stack direction="row" justifyContent="space-between">
                        <Text>{workplaceType}</Text>
                        <Text>
                          {formatDollarsAsUsd(incentive, {
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0,
                          })}
                        </Text>
                      </Stack>
                    }
                  />
                </ListItem>
                {index < sortedIncentives.length - 1 && <Divider />}
              </Fragment>
            ))}
          </List>
        </Stack>
      </CardContent>
    </WorkplaceReferralCard>
  );
}
